import axios from 'axios'

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + process.env.REACT_APP_API_TOKEN
  }
})

export default axiosConfig